<template>

  <Modal v-model="addContractorDialog" :mask-closable="false" width="600" draggable>
    <div slot="header"><strong>{{editMode?'Edit':'New'}} Contractor</strong></div>
    <div class="modal-content">
      <Form :model="contractorForm" :rules="ruleContractorForm" ref="contractorForm" :label-width="110">
        <FormItem label="Type" prop="type" style="display: inline-block">
          <RadioGroup v-model="contractorForm.type">
            <Radio label="ON_CONTRACT"><span>On Contract</span></Radio>
            <Radio label="RENTED"><span>Rented</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="status" style="float: right;">
          <i-switch v-model="contractorForm.status" title="Status" :style="contractorForm.status?'background: green':'background: red'"/>
        </FormItem>

        <FormItem prop="name" label="Name">
          <Input v-model="contractorForm.name"/>
        </FormItem>

        <FormItem prop="gstin" label="GSTIN">
          <Input v-model="contractorForm.gstin" :maxlength="15" class="capitalize-gstin"/>
        </FormItem>
        <FormItem prop="pan" label="PAN">
          <Input v-model="contractorForm.pan" :maxlength="10" class="capitalize-gstin"/>
        </FormItem>

        <FormItem prop="email" label="Email">
          <Input v-model="contractorForm.email"/>
        </FormItem>

        <FormItem prop="mobile" label="Mobile">
          <Input v-model="contractorForm.mobile" type="number"/>
        </FormItem>

        <FormItem prop="monthlyKms" label="Monthly KMs">
          <Input v-model="contractorForm.monthlyKms" type="number"/>
        </FormItem>

        <FormItem prop="city" label="City">
          <AutoComplete v-model="contractorForm.city"
                        @on-search="handleCitySearch" @on-focus="cityFilter2='%%'">
            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                    :key="index" :value="cityObj.city">
              <div class="ivu-select-item-div" @click="selectedCityCode=cityObj.shortCode">{{cityObj.city}}</div>
            </Option>
          </AutoComplete>
        </FormItem>

        <Card>
          <Row>
            <Col span="24">
              <Form :model="addressForm" :rules="addressRuleValidate" label-position="top" ref="addressForm">
                <Row :gutter="32">
                  <Col span="12">
                    <FormItem label="Address 1" prop="add1">
                      <Input placeholder="Enter your Address" v-model="addressForm.add1"></Input>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="Address 2" prop="add2">
                      <Input placeholder="Enter your Address" v-model="addressForm.add2"></Input>
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="32">
                  <Col span="12">
                    <FormItem label="City" prop="city">
                      <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}">
                        <template slot-scope="{ result: { loading, error, data } }">
                          <div v-if="loading"> Loading...</div>
                          <div v-else-if="error"> Error Occured. {{error}}</div>
                          <div v-else-if="data">
                            <AutoComplete placeholder="Search City"
                                          v-model="addressForm.city">
                              <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data.city">
                                <div  class="ivu-select-item-div" @click="addressForm.state=cityObj.state;selectedCityId=cityObj.id">{{cityObj.city}}</div>
                              </Option>
                            </AutoComplete>
                          </div>
                          <div v-else>
                            There are no City Available yet.
                          </div>
                        </template>
                      </ApolloQuery>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="State" prop="state">
                      <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}">
                        <template slot-scope="{ result: { loading, error, data } }">
                          <div v-if="loading"> Loading...</div>
                          <div v-else-if="error"> Error Occured. {{error}}</div>
                          <div v-else-if="data">
                            <AutoComplete placeholder="Search State"
                                          v-model="addressForm.state">
                              <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data.territories">
                                <div  class="ivu-select-item-div">{{stateObj.state}}</div>
                              </Option>
                            </AutoComplete>
                          </div>
                          <div v-else>
                            There are no State Available yet.
                          </div>
                        </template>
                      </ApolloQuery>
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="32">
                  <Col span="12">
                    <FormItem label="Area" prop="area">
                      <Select v-model="addressForm.area" filterable>
                        <Option v-for="(area,index) in areaArr" :value="area.area"
                                :label="area.area" :key="index">
                          <div  class="ivu-select-item-div">{{area.area}}</div>
                        </Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem label="PIN Code" prop="pincode">
                      <Input type="number" placeholder="Enter your PIN" v-model="addressForm.pincode"></Input>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>


      </Form>
    </div>
    <div slot="footer">
      <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addContractor" :loading="loading">
        <span v-if="!loading">SAVE</span>
        <span v-else>Loading...</span>
      </Button>
      <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyContractor">UPDATE</Button>
      <Button style="background: #999999; color: white;font-weight: bolder" @click="addContractorDialog=false">CANCEL</Button>
    </div>
  </Modal>

</template>

<script>
  import {GET_LAST_CONTRACTOR} from "../../graphql/queries/vehicle";
  import {
    INSERT_ADDRESS_OF_CONTRACTOR,
    UPDATE_CONTRACTOR_V2,
    UPDATE_CONTRACTOR_WITH_ADDRESS
  } from "../../graphql/mutations/vehicle";
  import ValidationRules from "../../Constants/ValidationRules";
  import {generateUUID} from "../../Constants/Constant";
  import moment from 'moment';
  import {SEARCH_CITY2, SEARCH_STATE} from "../../graphql/queries/territories";
  import Vue from 'vue';
  import {GET_AREAS_BY_CITY} from "../../graphql/queries/area";

  export default {
        apollo: {
          city: {
            query: SEARCH_CITY2,
            variables() {
              return {
                cityFilter: this.cityFilter2
              }
            },
            result ({ data, loading }) {
              if (!loading) {
                this.cityArr = data.city;
              }
            }
          },
          area: {
            query: GET_AREAS_BY_CITY,
            variables() {
              return {
                cityId: this.selectedCityId,
              }
            },
            result({data, loading}) {
              if (!loading) {
                this.areaArr = data.area;
              }
            }
          }
        },
        name: "AddContractor",
        data: function(){
          return{
            query_SEARCH_CITY: SEARCH_CITY2,
            query_SEARCH_STATE: SEARCH_STATE,
            addContractorDialog: false,
            contractorForm:{
              id: '',
              type: 'ON_CONTRACT',
              name: '',
              mobile: '',
              email: '',
              gstin: '',
              pan: '',
              monthlyKms: '',
              city: '',
              status: true
            },
            ruleContractorForm:{
              name: ValidationRules.textField('Name'),
              type: ValidationRules.selectField,
              email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
              mobile: ValidationRules.mobileNumber,
              monthlyKms: ValidationRules.numberField,
              city: ValidationRules.textField('City'),
            },
            addressForm: {
              id: '',
              add1: '',
              add2: '',
              area: '',
              pincode: null,
              city: '',
              state: ''
            },
            addressRuleValidate: {
              add1: ValidationRules.add2, area: ValidationRules.area,
              city: ValidationRules.city, state: ValidationRules.state
            },
            selectedCityId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
            areaArr: [],
            cityFilter2: '%%',
            cityArr: [],
            lastContractorCode: 'TCSUR0000',
            editMode: false,
            loading: false,
            selectedCityCode: 'SUR',
          }
        },
        methods:{
          reset: function(){
            this.$refs['contractorForm'].resetFields();
            this.$refs['addressForm'].resetFields();
          },
          handleCitySearch: _.debounce(function(val){
            this.cityFilter2 = '%' + val + '%'
          }, 500),
          generateContractorNumber(){
            let orderNum = 'TC' + this.selectedCityCode;
            let lastFourDigits = parseInt(this.lastContractorCode.substr(5)) + 1;
            if(lastFourDigits.toString().length == 1){
              lastFourDigits = '000' + lastFourDigits
            }else if(lastFourDigits.toString().length == 2){
              lastFourDigits = '00' + lastFourDigits
            }else if(lastFourDigits.toString().length == 3){
              lastFourDigits = '0' + lastFourDigits
            }
            return orderNum + lastFourDigits;
          },
          onAddContractor(){
            this.reset();
            this.editMode = false;
            this.addContractorDialog = true;
          },
          addContractor(){
            this.loading = true;
            this.$refs['contractorForm'].validate((valid) => {
              if (valid) {
                this.$refs['addressForm'].validate((addressValid) => {
                  if (addressValid) {
                    this.insertContractor();
                  }else{
                    this.loading = false
                  }
                })
              }else{
                this.loading = false
              }
            })
          },
          async insertContractor(){
            /* ---------------- GET LAST CONTRACTOR NUMBER ----------------- */
            let res = await this.$apollo.query({
              query: GET_LAST_CONTRACTOR,
              fetchPolicy: "network-only"
            })
            if(res.data.lastContractor.length){
              this.lastContractorCode = res.data.lastContractor[0].contractorCode;
            }
            let contractorCode = this.generateContractorNumber();
            /* ---------------x---------------x--------------x------------ */

            let response = await this.$apollo.mutate({
              mutation: INSERT_ADDRESS_OF_CONTRACTOR,
              variables: {
                object:{
                  ...this.addressForm,
                  id: generateUUID(),
                  pincode: this.addressForm.pincode?.toString(),
                  Contractor: { data: {
                      ...this.contractorForm,
                      id: generateUUID(),
                      createdAt: moment().format(),
                      contractorCode: contractorCode,
                      mobile: parseInt(this.contractorForm.mobile),
                    }}
                }
              }
            })
            if(response.data.insert_contractorAddress.returning[0].id){
              this.$Message.success('New Contractor added successfully!');
              this.reset();
              this.loading = false
              this.addContractorDialog = false;
            }
          },
          async onEditContractor(contractorData){
            this.reset();
            this.contractorForm.id = contractorData.id;
            this.contractorForm.type = contractorData.type;
            this.contractorForm.name = contractorData.name;
            this.contractorForm.mobile = contractorData.mobile;
            this.contractorForm.email = contractorData.email;
            this.contractorForm.gstin = contractorData.gstin;
            this.contractorForm.pan = contractorData.pan;
            this.contractorForm.status = contractorData.status;
            this.contractorForm.monthlyKms = contractorData.monthlyKms;
            if(contractorData.contractorAddress?.id){
              this.addressForm.id = contractorData.contractorAddress.id;
              this.addressForm.add1 = contractorData.contractorAddress.add1;
              this.addressForm.add2 = contractorData.contractorAddress.add2;
              this.addressForm.area = contractorData.contractorAddress.area;
              this.addressForm.city = contractorData.contractorAddress.city;
              this.addressForm.state = contractorData.contractorAddress.state;
              this.addressForm.pincode = contractorData.contractorAddress.pincode;
            }

            this.editMode = true;
            this.addContractorDialog = true;
            await Vue.nextTick();
            this.contractorForm.city = contractorData.city?contractorData.city:'';

          },
          modifyContractor(){
            this.$refs['contractorForm'].validate((valid) => {
              if (valid) {
                this.$refs['addressForm'].validate((addressValid) => {
                  if (addressValid && this.addressForm.id) {
                    this.updateContractor();
                  }else if(addressValid){
                    this.insertAddressAndUpdateContractor();
                  }
                })
              }
            })
          },
          async updateContractor(){
            let response = await this.$apollo.mutate({
              mutation: UPDATE_CONTRACTOR_WITH_ADDRESS,
              variables: {
                contractorId: this.contractorForm.id,
                contractorObj: {...this.contractorForm, mobile: parseInt(this.contractorForm.mobile)},
                addressId: this.addressForm.id,
                addressObj: {...this.addressForm, pincode: this.addressForm.pincode?.toString()}
              }
            })
            if(response.data){
              this.$Message.success('Contractor updated successfully!');
              this.reset();
              this.addContractorDialog = false;
            }
          },
          async insertAddressAndUpdateContractor(){
            let addressResponse = await this.$apollo.mutate({
              mutation: INSERT_ADDRESS_OF_CONTRACTOR,
              variables: {
                object: {
                  ...this.addressForm,
                  id: generateUUID(),
                  pincode: this.addressForm.pincode?.toString(),
                  contractorId: this.contractorForm.id
                }
              }
            })
            if(addressResponse.data){
              let contractorResponse = await this.$apollo.mutate({
                mutation: UPDATE_CONTRACTOR_V2,
                variables: {
                  contractorId: this.contractorForm.id,
                  contractorObj: {
                    ...this.contractorForm,
                    mobile: parseInt(this.contractorForm.mobile)
                  }
                }
              })
              if(contractorResponse.data){
                this.$Message.success('Contractor updated successfully!');
                this.reset();
                this.addContractorDialog = false;
              }
            }
          }
        },
      computed: {
        cityFilter () {
          return '%' + this.addressForm.city + '%'
        },
        stateFilter () {
          return '%' + this.addressForm.state + '%'
        }
      }
    }
</script>

<style scoped>
  /deep/ .ivu-select-item{
    padding: 0px 0px;
  }
  /deep/ .ivu-select-item-div{
    width: 100%;
    padding: 7px 16px;
  }
  /deep/ .ivu-auto-complete.ivu-select-dropdown{
    max-height: 200px !important;
  }
  .modal-content{
    max-height: 500px;
    overflow-y: scroll;
    padding: 0px 20px 0 0;
  }
  .modal-content::-webkit-scrollbar {
    width: 5px !important;
    height: 5px !important;
    display: block !important;
  }
  .modal-content::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 5px !important;
  }
</style>
